import KatalLogger from '@amzn/katal-logger';

export const logger = new KatalLogger({
  url: 'https://gqyojlcpnb.execute-api.us-east-1.amazonaws.com/prod/v1/log',
  maxLogLineSize: 10000, // default 5000
});
